import { ApiService, toModel } from '~/shared/api'
import { ResearchShowcaseApplication, ResearchShowcaseRequest } from '~/models/research-showcase'
import type {
  ResearchShowcaseApplicationDto,
  ResearchShowcaseRequestDto,
} from '~/models/research-showcase'
import { API_PREFIX } from '~/shared/const/request-services'
import { messages } from '~/shared/const/messages'

export class ResearchShowcaseFormsService extends ApiService {
  readonly urls = {
    application: `${API_PREFIX}/research-showcase/requests`,
    contactRequest: `${API_PREFIX}/research-showcase-cards/replies`,
  }

  sendApplication(dto: ResearchShowcaseApplicationDto): Promise<ResearchShowcaseApplication> {
    return this.http
      .request({
        method: 'POST',
        url: this.urls.application,
        data: dto,
        silent: true,
      })
      .then(toModel(ResearchShowcaseApplication, messages.errors.create))
  }

  sendRequest(dto: ResearchShowcaseRequestDto): Promise<ResearchShowcaseRequest> {
    return this.http
      .request({
        method: 'POST',
        url: this.urls.contactRequest,
        data: dto,
        silent: true,
      })
      .then(toModel(ResearchShowcaseRequest, messages.errors.create))
  }
}
